import { requisitionQuantityError, requisitionUnitOptions } from "./requisitionUnits";

export const marketplaceLineKey = (line) => line._marketplaceKey || JSON.stringify([
  Number(line.item_id), Number(line.supplier_id), Number(line.unit_id),
  line.display_unit_level || "unit", line.destination_location_id || null,
]);
export const marketplacePriceKey = (line, date) => JSON.stringify([Number(line.item_id), Number(line.supplier_id), Number(line.unit_id), date]);
export const hasMarketplacePrice = (price) => Boolean(price) && ["tender", "last_purchase", "manual"].includes(price.source || price.price_source)
  && price.unit_price !== null && price.unit_price !== "" && Number.isFinite(Number(price.unit_price)) && Number(price.unit_price) >= 0;
const gcd = (a, b) => b ? gcd(b, a % b) : a;
export function marketplaceQuantityStep(item) {
  const multiple = Number(item?.purchase_multiple) > 0 ? Number(item.purchase_multiple) : 1;
  const scaled = Math.round(multiple * 1e8);
  return item?.subunit_id && Number(item.pack_size) > 0 ? scaled / gcd(scaled, 1e8) : multiple;
}
export function marketplaceInitialQuantity(item) {
  const step = marketplaceQuantityStep(item);
  return Number((Math.ceil(Math.max(Number(item?.minimum_purchase_quantity) || step, step) / step - 1e-9) * step).toFixed(8));
}
export function marketplaceQuantityError(line, item, units, languageId, t) {
  const error = requisitionQuantityError(line, item, units, languageId, t);
  if (error) return error;
  const quantity = Number(line.quantity), minimum = Number(item?.minimum_purchase_quantity), multiple = Number(item?.purchase_multiple);
  if (!Number.isFinite(quantity) || quantity <= 0) return t("Enter a quantity greater than zero.");
  if (minimum > 0 && quantity < minimum - 1e-9) return languageId === "es" ? `Cantidad mínima: ${minimum}.` : `Minimum purchase quantity: ${minimum}.`;
  if (multiple > 0 && Math.abs(quantity / multiple - Math.round(quantity / multiple)) > 1e-8) return languageId === "es" ? `Elige un múltiplo de ${multiple}.` : `Choose a multiple of ${multiple}.`;
  return "";
}
export function marketplacePackaging(line, item, units, languageId) {
  const options = requisitionUnitOptions(line, item, units, languageId);
  const number = (value) => Number(value).toLocaleString(languageId, { maximumFractionDigits: 8 });
  return options.length < 2 ? options[0]?.label || "—" : `${options[0].label} · ${number(item.pack_size)} × ${options[1].label}${options.length > 2 ? ` · ${number(item.subunit2_size)} ${options[2].label}` : ""}`;
}
